import {
  ExplorerLinkType,
  getExplorerUrl,
} from 'src/common/utils/web3/getExplorerUrl'
import { shortenAddress } from 'thirdweb/utils'
import ExternalLink, { ExternalLinkProps } from './ExternalLink'
import { useActiveWalletChain } from 'thirdweb/react'
import { getActiveOrDefaultChain } from 'src/common/utils/web3/network'

interface ExplorerLinkProps
  extends Omit<ExternalLinkProps, 'children' | 'link'> {
  type: ExplorerLinkType
  hash: string
  label?: string
  hashLength?: number
}

const ExplorerLink: React.FC<ExplorerLinkProps> = ({
  type,
  hash,
  label,
  hashLength = 4,
  iconSize = 15,
  ...props
}) => {
  const activeChain = useActiveWalletChain()
  const defaultValue = getActiveOrDefaultChain(activeChain?.id).id

  const explorerUrl = getExplorerUrl({
    type,
    chainId: defaultValue,
    hash,
  })

  return (
    <ExternalLink
      link={explorerUrl}
      iconSize={iconSize}
      iconPosition='right'
      {...props}
    >
      {label || shortenAddress(hash, hashLength)}
    </ExternalLink>
  )
}

export default ExplorerLink
